import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons'

import { formatCurrency, formatPercent } from '../../lib/formatters';

export default function Term({
  parentSelectedTerm,
  setParentTerm,
  term,
  cart
}) {
  const [selectedTerm, setSelectedTerm] = useState(parentSelectedTerm);

  useEffect(() => {
    if (setParentTerm) setParentTerm(selectedTerm);
  }, [selectedTerm]);

  const termOnClick = (term) => {
    setSelectedTerm({
      term: parseInt(term.get('term')),
      term_period: term.get('term_period'),
      payment: parseFloat(term.get('monthly_payment'))
    });
  };

  function Interest() {
    return (
      <>
        <p className="is-size-6" style={styles.paymentsInterest}>
          {formatCurrency(term.get('total_fees'))} total interest
          <span style={styles.circleIcon}>
            <FontAwesomeIcon icon={faCircle} />
          </span>
          First payment 31 days after shipment
        </p>
      </>
    );
  }

  function InterestAndBorrowerFee() {
    return (
      <div className="columns is-mobile mb-0">
        <div className="column is-one-half mb-0 pb-0">
          {Interest()}
        </div>
        <div className="column is-one-half mb-0 pb-0">
          <p style={styles.orderFee}>ORDER FEE</p>
          <p>{formatCurrency(cart.borrower_fee * cart.base_amount)}&nbsp;({formatPercent(cart.borrower_fee * 100)})</p>
        </div>
      </div>
    );
  }

  if (term && term.get('term_period') === 'biweekly') {
    return (
      <>
        <div
          style={{ padding: '1.2rem' }}
          className={classNames("mb-4 term-container", {
            'term-available': setParentTerm,
            'selected': parentSelectedTerm && term.get('term') === parentSelectedTerm.term
          })}
          key={term.get('term')}
          id={"term-" + term.get('term')}
          data-term={term.get('term')}
          data-payment={formatCurrency(term.get('monthly_payment'))}
          onClick={() => termOnClick(term)}
        >
          <div className="is-size-5 has-text-centered has-text-weight-bold">
            4 payments of <span className="text-green-highlight">${term.get('monthly_payment')}</span>
          </div>
          <div
            style={styles.fourPaymentsContainer}
            className="is-size-6 has-text-centered has-text-grey">
            $0 Interest
            <span style={styles.circleIcon}> <FontAwesomeIcon icon={faCircle} /> </span>
            Every 2 weeks
            <span style={styles.circleIcon}>
              <FontAwesomeIcon icon={faCircle} />
            </span>
            First payment today
          </div>
        </div>
        <div className="is-size-5 has-text-centered" style={styles.payOverTimeDiv}>
          <span className='is-size-5 has-text-centered has-text-weight-bold' style={styles.orPay}>
            Or pay over time
          </span>
        </div>
        <div className="has-text-centered has-text-grey is-size-6" style={styles.earlyPay}>
          No early pay-off fees / 0% for 30 days
        </div>
      </>
    )
  }

  if (term && term.get('available')) {
    return (
      <div
        style={styles.monthlyPaymentsDiv}
        className={classNames("mb-4 term-container", {
          'term-available': setParentTerm,
          'selected': parentSelectedTerm && term.get('term') === parentSelectedTerm.term
        })}
        key={term.get('term')}
        id={"term-" + term.get('term')}
        data-term={term.get('term')}
        data-payment={formatCurrency(term.get('monthly_payment'))}
        onClick={() => termOnClick(term)}
      >
        <div>
          <div className=" has-text-centered is-size-5 ">
            {
              term.get('term') === 30 && term.get('term_period') === 'days' ? (
                <strong className='mx-1'>Net 30</strong>
              ) : (
                <strong>
                  {term.get('term')}
                  {term.get('term') === 1 ? ' month ' : ' monthly payments of '}
                </strong>
              )
            }
            <span className="text-green-highlight has-text-weight-bold">
              {formatCurrency(term.get('monthly_payment'))}
            </span>
          </div>
        </div>

        <div>
          <div className="is-one-third has-text-centered has-text-grey is-size-7">
            {cart && cart.borrower_fee > 0.0 ? InterestAndBorrowerFee() : Interest()}
          </div>
        </div>
      </div>
    )
  }

  if (term && !term.get('available')) {
    return (
      <div
        className="mb-4 term-container term-unavailable"
        key={term.get('id')}
        id={"term-" + term.get('id')}
        data-term={term.get('term')}
        data-payment={formatCurrency(term.get('monthly_payment'))}
      >

        <div className="columns is-mobile">
          <div className="column is-one-half is-size-5">
            <p><strong>{term.get('term')} {term.get('term') === 1 ? 'month' : 'months'}</strong></p>
          </div>
          <div className="column is-one-half has-text-right">
            <p className="has-text-danger has-text-weight-bold">
              <span>Unavailable</span> <span className="icon" data-tooltip title="This option exceeds your payback capacity">
                <FontAwesomeIcon icon={['fal', 'info-circle']} /></span>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  fourPaymentsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    paddingTop: '0.3rem'
  },
  paymentsInterest: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  circleIcon: { fontSize: '.3em' },
  orderFee: { whiteSpace: 'nowrap' },
  payOverTimeDiv: {
    width: '100%',
    height: '17px',
    borderBottom: '2.6px solid black',
    textAlign: 'center',
    marginTop: '2rem'
  },
  orPay: { backgroundColor: 'white', padding: '1.2em' },
  earlyPay: { padding: '1.1rem' },
  monthlyPaymentsDiv: { padding: '1.5rem', margin: '1.3rem auto' },
}
